import { RestTypeId } from '../types/RestType';

export default function (types: number[]): RestTypeId[] {
    if (!types) return [];

    // Один проход на построение Set вместо пяти линейных includes по types.
    const typeIds = new Set(types);
    const result: RestTypeId[] = [];

    if (typeIds.has(1)) result.push(RestTypeId.Beach);
    if (typeIds.has(2)) result.push(RestTypeId.City);
    if (typeIds.has(3)) result.push(RestTypeId.Mountain);
    if (typeIds.has(4)) result.push(RestTypeId.Wellness);
    if (typeIds.has(11)) result.push(RestTypeId.Eco);

    return result;
}